"use client";

import { Phone, MapPin, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-primary-light/20 animate-pulse rounded" />
        <div className="h-4 w-20 bg-primary-light/20 animate-pulse rounded" />
        <div className="h-4 w-28 bg-primary-light/20 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-foreground-dark hover:text-secondary transition-colors duration-[var(--duration-medium)]">
          {item.label}
        </Link>)}
      <Link to="/contact/" className="text-foreground-dark hover:text-secondary transition-colors duration-[var(--duration-medium)]">
        Contact
      </Link>
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = ["Preventive Dentistry", "Restorative Dentistry", "Cosmetic Dentistry", "Emergency Dental Care", "Dental Implants", "Root Canal Therapy"];
  return <footer ref={ref} className={`bg-dark-background border-t border-secondary/10 text-foreground-dark py-16 px-4 transition-opacity duration-[var(--duration-slow)]`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {}
          <div className="flex flex-col gap-4" data-index={0}>
            <h3 className="text-xl font-semibold text-foreground-dark mb-2">
              Alpha Dental
            </h3>
            <div className="flex items-start gap-3">
              <MapPin className="size-5 text-secondary shrink-0 mt-0.5" />
              <address className="not-italic text-foreground-dark/90">
                916 Coronado Blvd<br />
                Universal City, TX 78148
              </address>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="size-5 text-secondary shrink-0" />
              <Link to="mailto:alphainfo916@gmail.com" className="text-foreground-dark/90 hover:text-secondary transition-colors duration-[var(--duration-medium)]">
                alphainfo916@gmail.com
              </Link>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="size-5 text-secondary shrink-0" />
              <Link to="tel:2107755177" className="text-foreground-dark/90 hover:text-secondary transition-colors duration-[var(--duration-medium)]">
                (210) 775-5177
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4" data-index={1}>
            <h3 className="text-xl font-semibold text-foreground-dark mb-2">
              Quick Links
            </h3>
            <MenuProvider menu_id="4">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-4" data-index={2}>
            <h3 className="text-xl font-semibold text-foreground-dark mb-2">
              Our Services
            </h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i} className="text-foreground-dark/90">
                  {service}
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4" data-index={3}>
            <h3 className="text-xl font-semibold text-foreground-dark mb-2">
              Get in Touch
            </h3>
            <div className="flex flex-col gap-3">
              <Button asChild className="bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 focus:!bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] w-full justify-center">
                <Link to="tel:2107755177">
                  <Phone className="size-4" />
                  Call Now
                </Link>
              </Button>
              <Button asChild className="bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 focus:!bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] w-full justify-center">
                <Link to="https://www.appointnow.com/?P=4826&O=101&PT=0&campaignID=" newTab>
                  Schedule With Us
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="mt-10 px-4">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs text-center text-foreground-dark/75 leading-relaxed">
              By providing a mobile number, I agree that Alpha Dental may send me an automated appointment and dental marketing message at the number I provided above. I understand my consent is not required to purchase.
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="border-t border-secondary/10 mt-12 pt-6">
        <div className="max-w-7xl mx-auto px-4">
          {}
          <div className="hidden md:flex items-center justify-center text-xs text-foreground-dark/80">
            <span>&copy;2026 Alpha Dental</span>
            <span className="mx-3">|</span>
            <Link to="/privacy-policy/" className="hover:text-secondary transition-colors duration-[var(--duration-medium)]">
              Privacy Policy
            </Link>
            <span className="mx-3">|</span>
            <span>Web Design, Digital Marketing & SEO By Roshan Deshmukh</span>
          </div>

          {}
          <div className="flex md:hidden flex-col items-center gap-2 text-xs text-foreground-dark/80 text-center">
            <span>&copy;2026 Alpha Dental</span>
            <Link to="/privacy-policy/" className="hover:text-secondary transition-colors duration-[var(--duration-medium)]">
              Privacy Policy
            </Link>
            <span>Web Design, Digital Marketing & SEO By Roshan Deshmukh</span>
          </div>
        </div>
      </div>
    </footer>;
}